/**
 * PayPal Payments Studio rendert das Label des Cart-Buttons hart auf Englisch
 * ("Checkout with" + Logo). Die App bietet dafür keine Einstellung, also
 * ersetzen wir den Text hier. Der Button wird asynchron in den Cart-Drawer
 * gehängt und bei jedem Cart-Update neu gebaut, deshalb ein MutationObserver.
 */
(function () {
  const scriptElement = document.querySelector('script[data-paypal-label-lang]');
  const lang = (scriptElement && scriptElement.getAttribute('data-paypal-label-lang')) || 'en';

  // Der Text steht vor dem PayPal-Logo, ergibt also "<Label> PayPal".
  const labels = {
    de: 'Bezahlen mit',
    nl: 'Betalen met',
    fr: 'Payer avec',
    it: 'Paga con',
    es: 'Pagar con',
    da: 'Betal med',
    sv: 'Betala med',
    nb: 'Betal med',
    no: 'Betal med',
    fi: 'Maksa palvelulla',
    pl: 'Zaplac przez',
    cs: 'Zaplatit pres',
  };

  const label = labels[lang];
  if (!label) return;

  function translate(root) {
    const nodes = root.querySelectorAll ? root.querySelectorAll('.paypal-button__text') : [];
    nodes.forEach(function (node) {
      if (node.textContent.trim() !== label) node.textContent = label;
    });
  }

  translate(document);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList.contains('paypal-button__text')) {
          if (node.textContent.trim() !== label) node.textContent = label;
        } else {
          translate(node);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
